import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const LineChartGraphSuccess = props => {
  const data = props.data.map(item => {
    return {
      month: item.month,
      year: item.year,
      successRate: item.total ? Math.floor(100 * item.success/item.total) : 0,
      _id: item._id + 'x'
    };
  })

  return (
      <ResponsiveContainer width="100%" minHeight={300}>
        <LineChart
          data={data}
          margin={{
            top: 5,
            right: 5,
            left: -20,
            bottom: 45,
          }}
        >
          <CartesianGrid />
          <XAxis xAxisId="0" dataKey="month" />
          <XAxis xAxisId="1" dataKey="year" allowDuplicatedCategory={false} />
          <YAxis tickFormatter={(tick) => {
            return `${tick}%`;
          }} />
          <Legend />
          <Tooltip />
          <Line dataKey="successRate" stroke="#0BD11E" activeDot={{ r: 4 }} />
        </LineChart>
      </ResponsiveContainer>
  );
}

export default LineChartGraphSuccess

